import type { IAugmentedJQuery, IDirective, IScope, ITimeoutService } from 'angular';
import { bindRichTooltip } from './rich_tooltip_trigger.core';

/**
 * base-tooltip に付けて、吹き出しを hover / click(タップ) / キーボードfocus / Esc / 外側クリックで
 * 表示制御する属性ディレクティブ（実ロジックは rich_tooltip_trigger.core）。base-tooltip は表示専用のまま。
 * 非活性(aria-disabled)ボタンの案内tooltip等、hover 以外でも出したい用途向け。
 *
 * 使用例: <base-tooltip placement="bottom" rich-tooltip-trigger>...</base-tooltip>
 */
// @ts-expect-error angular は vendor が供給するグローバル(UMD)
angular.module('inspinia').directive('richTooltipTrigger', [
  '$timeout',
  ($timeout: ITimeoutService): IDirective => ({
    restrict: 'A',
    link: (scope: IScope, element: IAugmentedJQuery) => {
      let teardown = (): void => {};
      // transclude 後に DOM へ配線するため 1tick 遅延させる
      const timer = $timeout(() => {
        teardown = bindRichTooltip(element[0]);
      });
      // $destroy は同期登録。timer 発火前に破棄されてもキャンセル＋解除でリスナーを残さない
      scope.$on('$destroy', () => {
        $timeout.cancel(timer);
        teardown();
      });
    },
  }),
]);
